import { ComponentEvents } from "global/interfaces/component.interface";

const EVENT_PREFIX = 'MoleculeVideoOverlayEvents__';


/** The type of custom events emitted */
export type MoleculeVideoOverlayEventTypes = {
	playButtonClicked: true;
};


export const MoleculeVideoOverlayEvents: ComponentEvents = {
	/** The custom event emitted when the button is clicked */
	playButtonClicked: EVENT_PREFIX + 'buttonClicked',
};
